export default "__VITE_ASSET__c7d74348__"